
export const environment =
{
  production: 'true',
  apiUrl: 'https://customerapi.cdlsinext.com/',
  chatApiUrl: 'https://api.cdlsinext.com/api/',
  debug: 'false'
}
